import React from 'react';
import { styled, keyframes, alpha } from '@mui/material/styles';

const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const glowAnimation = keyframes`
  0% { opacity: 0.3; }
  50% { opacity: 0.5; }
  100% { opacity: 0.3; }
`;

const floatAnimation = keyframes`
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
  100% { transform: translateY(0px) rotate(360deg); }
`;

const BackgroundWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: 'hidden',
  zIndex: -1,
  background: `linear-gradient(-45deg, 
    ${alpha(theme.palette.primary.main, 0.15)} 0%,
    ${alpha(theme.palette.secondary.main, 0.15)} 25%,
    ${alpha(theme.palette.primary.dark, 0.15)} 51%,
    ${alpha(theme.palette.secondary.dark, 0.15)} 100%)`,
  backgroundSize: '400% 400%',
  animation: `${gradientAnimation} 15s ease infinite`,
}));

const GlowingOrb = styled('div')(({ theme, size, top, left, delay }) => ({
  position: 'absolute',
  width: size,
  height: size,
  borderRadius: '50%',
  top: `${top}%`,
  left: `${left}%`,
  background: `radial-gradient(circle at 30% 30%, 
    ${alpha(theme.palette.primary.main, 0.4)},
    ${alpha(theme.palette.primary.dark, 0.1)})`,
  boxShadow: `0 0 ${size/2}px ${alpha(theme.palette.primary.main, 0.3)}`,
  animation: `${glowAnimation} 4s ease-in-out infinite, 
              ${floatAnimation} 6s ease-in-out infinite`,
  animationDelay: `${delay}s`,
}));

const BackgroundOverlay = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: `radial-gradient(circle at 50% 50%, 
    transparent 0%,
    ${alpha(theme.palette.background.default, 0.3)} 100%)`,
  backdropFilter: 'blur(100px)',
}));

const AnimatedBackground = () => {
  const orbs = [
    { size: 300, top: 20, left: 10, delay: 0 },
    { size: 200, top: 60, left: 80, delay: 1 },
    { size: 250, top: 40, left: 40, delay: 2 },
    { size: 180, top: 80, left: 20, delay: 3 },
    { size: 220, top: 10, left: 70, delay: 4 },
  ];

  return (
    <BackgroundWrapper>
      {orbs.map((orb, index) => (
        <GlowingOrb
          key={index}
          size={orb.size}
          top={orb.top}
          left={orb.left}
          delay={orb.delay}
        />
      ))}
      <BackgroundOverlay />
    </BackgroundWrapper>
  );
};

export default AnimatedBackground;